export default __webpack_public_path__ + "static/media/grateful-calender.69c03779.webp";